<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <div>
                    <a href="index.html" class="logo-light">
                        <img [src]="logo" alt="logo" class="logo-lg" style="width: 35px;
                        height: 35px;">
                        <!-- <img src="assets/images/logo-sm.png" alt="small logo" class="logo-sm"> -->
                    </a>
                    {{year}} GEMS Institutions
                </div>
            </div>
            <div class="col-md-6">
                <div class="d-none d-md-flex gap-4 align-item-center justify-content-md-end footer-links">
                </div>
            </div>
        </div>
    </div>
    <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
        <li>Developed By
            <a href="https://agoo.in">
                <img src="assets/images/agoo_logo.png" style="height: 25px;" alt="agoo">
            </a>
        </li>
    </ul>
</footer>